import { render, staticRenderFns } from "./TitleLabel.vue?vue&type=template&id=35ea9647&scoped=true&"
import script from "./TitleLabel.vue?vue&type=script&lang=js&"
export * from "./TitleLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ea9647",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ea9647')) {
      api.createRecord('35ea9647', component.options)
    } else {
      api.reload('35ea9647', component.options)
    }
    module.hot.accept("./TitleLabel.vue?vue&type=template&id=35ea9647&scoped=true&", function () {
      api.rerender('35ea9647', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Label/TitleLabel.vue"
export default component.exports